import React, {useEffect, useState} from "react";
import {PageTitle} from "../../components/Common/PageTitle/PageTitle";
import {InsuranceProviderSearchDropdown} from "../../components/Info/SearchBar/InsuranceProviderSearchDropdown";
import {Button, Flex} from "antd";
import {Paths} from "../../models/Paths";
import {AgreementRow} from "../../components/Info/AgreementRow/AgreementRow";
import {Voucher, VoucherBodyFilter} from "../../models/Info/voucher.model";
import {InformationService} from "../../services/InformationService";
import "./Info.css";
import {SpinLuxottica} from "../../components/Common/SpinLuxottica/SpinLuxottica";
import {EmptyLuxottica} from "../../components/Common/Empty/EmptyLuxottica";
import {usePage} from "../../customHooks/UsePage";
import {QueryParameterModel} from "../../models/QueryParameter";
import {isNil} from "lodash";
import {LogService} from "../../services/LogService";
import {FileAddOutlined, RedoOutlined} from "@ant-design/icons";
import {AuthService} from "../../services/AuthService";
import {useModal} from "../../utils/modals";
import {BasicFormMethod, BasicFormModal} from "../../components/Common/BasicComponents/BasicFormModal";
import {InsuranceProviderEclaim} from "../../models/InsuranceProvider";
import {AdminHttpService} from "../../services/Http/SearchTableService";
import {FilterString} from "../../components/Common/BasicComponents/filters/FilterString";
import {FilterSelect} from "../../components/Common/BasicComponents/filters/FilterSelect";
import {FilterTextEditor} from "../../components/Common/BasicComponents/filters/FilterTextEditor";
import {Utils} from "../../services/Utils";
import {InsuranceRefundType} from "../../models/Contract";
import {LocationGroupCode} from "../../models/LocationGroupCode";

export function Info() {
    const [vouchers, setVouchers] = useState<Array<Voucher>>([])
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [bodyFilters,setBodyFilters] = useState<VoucherBodyFilter>({
        insuranceProviderId:null
    })
    const {
        isOpen: isCreateFormModalOpen,
        open: openCreateFormModal,
        close: closeCreateFormModal
    } = useModal();

    const {
        page,
        lastPage,
        updateValues,
        incrementPage,
        getPageQueryParameters,
        getDefaultPageQueryParameters,
        resetPagination
    } = usePage({ page:0, size:20, lastPage:1, allItemsNumber:0 }, 'id', 'ASC');

    useEffect(() => {
        loadData(getPageQueryParameters());
    }, []);

    const loadData = async (
        queryParameters:QueryParameterModel[],
        bodyFilters?:VoucherBodyFilter,
        isFilterChange:boolean=false
    ) =>{
        setIsLoading(true);
        try {
            let res;
            if (isNil(bodyFilters)) {
                res = await InformationService.getVoucherList(queryParameters)
            } else {
                res = await InformationService.getVoucherListPost(queryParameters,bodyFilters ?? undefined);
            }
            updateValues(res.currentPage, res.allItemsNumber, res.totalPages)
            if(isFilterChange === false ){
                setVouchers(vouchers.concat(res.items));
            } else {
                setVouchers(res.items);
            }
        } finally {
            setIsLoading(false)
        }
    }

    const renderVouchers = () => {
        const voucherList = vouchers.map((voucher) =>
            <li key={voucher.id}>
                <AgreementRow
                    id={voucher.id}
                    insuranceProviderId={voucher.insuranceProviderId}
                    insuranceProviderMetadata={voucher.insuranceProviderMetadata}
                    agreement={voucher.agreement}
                    visus={voucher.visus}
                    refundCondition={voucher.refundConditions}
                    code={voucher.code}//TODO REFACTORING
                    locationGroupCode={voucher.locationGroupCode}
                />
            </li>
        );
        return <ul className={"voucher-list"}  onScroll={handleScroll}>{voucherList}</ul>
    }

    const handleScroll = (e:any) => {
        const scrollHeight = e.target.scrollHeight;
        const scrollTop = Math.round(e.target.scrollTop);
        const clientHeight = e.target.clientHeight;
        const bottom = scrollHeight - scrollTop === clientHeight;
        LogService.info("isBottom", bottom, scrollHeight, scrollTop, scrollHeight - scrollTop, clientHeight)
        if(bottom){
            if(page !== (lastPage-1) ){
                let queryParameters:QueryParameterModel[] = incrementPage();
                loadData(queryParameters,bodyFilters)
            }
        }
    }

    function onChange(element:number){
        bodyFilters.insuranceProviderId = element;
        setBodyFilters(bodyFilters);
        resetPagination();
        loadData(getDefaultPageQueryParameters(), bodyFilters, true);
    }

    const formInputFields =[
        <FilterString dataKey={"code"} label={"Codice"} required={true}></FilterString>,
        <FilterSelect dataKey={"agreement"} label={"Tipo di Rimborso"}
                      options={Utils.enumToSelectOptions(InsuranceRefundType)} required={true}></FilterSelect>,
        <FilterSelect dataKey={"insuranceProviderId"} label={"Assicurazione"} required={true}
                      api={{
                          url: AdminHttpService.URL_ADMIN_INSURANCE_PROVIDERS,
                          value: "id",
                          label: "description",
                          sendAsObject: false
                      }} showSearch={true}></FilterSelect>,
        <FilterSelect dataKey={"company"} label={"Gruppo di Azienda"}  options={Utils.enumToSelectOptions(LocationGroupCode)} required={true}></FilterSelect>,
        <FilterString dataKey={"refundConditions"} label={"Condizioni di Rimborso"} ></FilterString>,
        <FilterString dataKey={"visus"} label={"Visus"} ></FilterString>,

        <FilterTextEditor containerProps={{style:{height:'200px'}}} dataKey={"shopInfo"} label={"Informazioni sul negozio"}  ></FilterTextEditor>,
    ]

    return <>
        <Flex vertical>
            <SpinLuxottica loading={isLoading}>
                <Flex align={"center"} justify={"space-between"}>
                    <PageTitle title={"Info convenzioni"} backTo={Paths.HOME}>
                    </PageTitle>

                    <Flex align={"center"} gap={10}>
                        {AuthService.isAdmin() ?
                            <Button icon={<FileAddOutlined/>} type={"primary"} key="download"
                                    onClick={() => openCreateFormModal()}>
                                Aggiungi Convenzioni
                            </Button> : undefined}


                        <InsuranceProviderSearchDropdown onChange={(element: number) => {
                            onChange(element);
                        }}></InsuranceProviderSearchDropdown>
                        <Button icon={<RedoOutlined />} onClick={()=>{
                            if(bodyFilters.insuranceProviderId)
                                loadData(getDefaultPageQueryParameters(), bodyFilters, true);
                            else
                                loadData(getDefaultPageQueryParameters());
                        }}></Button>

                    </Flex>
                </Flex>


                {vouchers && vouchers.length > 0 ?
                    renderVouchers()
                    : <EmptyLuxottica></EmptyLuxottica>
                }

                {isCreateFormModalOpen &&
                    <BasicFormModal<InsuranceProviderEclaim> urlPath={AdminHttpService.URL_ADMIN_VOUCHERS} method={BasicFormMethod.CREATE}
                                                             isOpen={isCreateFormModalOpen} onOk={closeCreateFormModal} onCancel={closeCreateFormModal}
                                                             inputFields={formInputFields} title={"Aggiungi convenzioni"} ></BasicFormModal>}

            </SpinLuxottica>

        </Flex>


    </>
}